module.exports = __webpack_public_path__ + "static/media/DE_Ordforståelse.645d8cb2.mp4";